class SearchForm extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    if (!this.input) return;
    this.events = new AbortController();
    const options = { signal: this.events.signal };
    this.input.form.addEventListener('reset', event => this.onFormReset(event), options);
    this.input.addEventListener('input', () => {
      clearTimeout(this.changeTimer);
      this.toggleResetButton();
      this.onInputChange?.();
      this.changeTimer = setTimeout(() => this.onChange(), 300);
    }, options);
  }

  disconnectedCallback() {
    clearTimeout(this.changeTimer);
    this.events?.abort();
  }

  toggleResetButton() {
    this.resetButton?.classList.toggle('hidden', !this.input.value.length);
  }

  onChange() {
    this.toggleResetButton();
  }

  onFormReset(event) {
    event.preventDefault();
    clearTimeout(this.changeTimer);
    this.input.value = '';
    this.onInputChange?.();
    this.toggleResetButton();
    this.input.focus();
  }
}
customElements.define('search-form', SearchForm);
